import { useFonts as expoUseFonts } from 'expo-font'; // Aliased import
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import Ionicons from '@expo/vector-icons/Ionicons';

/**
 * Font loading configuration
 *
 * NOTE: We've patched expo-font to increase the font loading timeout from 6s to 12s
 * to prevent "timeout exceeded" errors on slow mobile connections.
 * See: CarDoo/patches/expo-font+13.3.2.patch
 * Related Sentry issue: DOOCARS-13
 */

export const fontFamilies = {
  satoshi: {
    regular: 'Satoshi-Regular',
    medium: 'Satoshi-Medium',
    bold: 'Satoshi-Bold',
    light: 'Satoshi-Light', // TEST: Satoshi-Light is defined
  },
  francy: 'Francy',
  chillaxVariable: 'Chillax-Variable', // TEST: Chillax-Variable is defined
  // Add other font families here if needed
};

// Renamed exported function to useFonts
export const useFonts = () => {
  const [fontsLoaded, error] = expoUseFonts({
    // Use the aliased original hook
    'Satoshi-Regular': require('../../assets/fonts/Satoshi-Regular.ttf'),
    'Satoshi-Medium': require('../../assets/fonts/Satoshi-Medium.ttf'),
    'Satoshi-Bold': require('../../assets/fonts/Satoshi-Bold.ttf'),
    'Satoshi-Light': require('../../assets/fonts/Satoshi-Light.ttf'),
    Francy: require('../../assets/fonts/Francy-Regular.ttf'),
    'Chillax-Variable': require('../../assets/fonts/Chillax-Variable.ttf'),
    ...MaterialCommunityIcons.font,
    ...Ionicons.font,
  });
  return { fontsLoaded, error };
};
